







































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Email from '@/components/icons/Email.vue';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton,
    Email
  }
})
export default class EnableCampaign extends Vue {
  @Prop() total!: number;
  @Prop() onConfirm!: any;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleConfirm() {
    this.handleClose();
    this.onConfirm();
  }

  get tPrefix() {
    return 'customerImport.overview.modals';
  }

  get disclaimerPlural() {
    if (this.total > 1) return 'plural';
    return 'singular';
  }
}
